export default __webpack_public_path__ + "static/media/doc2.d9dcdafa.jpg";